'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var constants = require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
var utils = require('./utils-0dcaf4b7.js');
var index = require('./index-bb59568f.js');
require('./calendar-header-9cff0d7c.js');
var calendarView = require('./calendar-view-4ae40c54.js');
var moment = _interopDefault(require('moment'));

var isSameDates = function (date1, date2) { return date1.isSame(date2, 'date'); };

var isDatesActive = function (day, activeDays) { var _a; return (_a = activeDays === null || activeDays === void 0 ? void 0 : activeDays.some(function (activeDay) { return isSameDates(day, activeDay); })) !== null && _a !== void 0 ? _a : false; };
var checkActiveDays = function (day, activeDays) { return (isDatesActive(day, activeDays) ? 'active' : null); };

var useMonthState = function (value, onNextMonthClick, onPreviousMonthClick) {
    var _a = tslib_es6.__read(React.useState(moment().startOf('month')), 2), month = _a[0], setMonth = _a[1];
    React.useEffect(function () {
        var _a;
        setMonth(((_a = value === null || value === void 0 ? void 0 : value.clone()) !== null && _a !== void 0 ? _a : moment()).startOf('month'));
    }, [value]);
    var nextMonth = React.useCallback(function () {
        var nextMonthValue = month.clone().add(1, 'month');
        setMonth(nextMonthValue);
        if (onNextMonthClick) {
            onNextMonthClick(nextMonthValue);
        }
    }, [month, setMonth, onNextMonthClick]);
    var previousMonth = React.useCallback(function () {
        var previousMonthValue = month.clone().add(-1, 'month');
        setMonth(previousMonthValue);
        if (onPreviousMonthClick) {
            onPreviousMonthClick(previousMonthValue);
        }
    }, [month, setMonth, onPreviousMonthClick]);
    return {
        month: month,
        nextMonth: nextMonth,
        previousMonth: previousMonth,
    };
};
var isDateUnavailable = function (day, unavailableDays) { var _a; return (_a = unavailableDays === null || unavailableDays === void 0 ? void 0 : unavailableDays.some(function (unavailableDay) { return isSameDates(day, unavailableDay); })) !== null && _a !== void 0 ? _a : false; };
var checkMinMax = function (day, minDate, maxDate) {
    var isInactive = (!!minDate && day.isBefore(minDate, 'date'))
        || (!!maxDate && day.isAfter(maxDate, 'date'));
    return isInactive ? 'inactive' : null;
};
var checkCurrentMonth = function (day, month, onlyCurrentMonthAvailable) {
    if (day.month() !== month.month())
        return onlyCurrentMonthAvailable ? 'inactive' : 'adjacentMonth';
    return null;
};
var checkUnavailableDays = function (day, unavailableDays) { return (isDateUnavailable(day, unavailableDays) ? 'unavailable' : null); };
var checkActiveDay = function (day, value) { return (value && isSameDates(day, value) ? 'active' : null); };
var checkAvailableDays = function (day, showCurrentDate) { return (showCurrentDate && isSameDates(day, moment()) ? 'current' : 'available'); };
var getDayStatus = function (day, month, value, unavailableDays, minDate, maxDate, showCurrentDate, onlyCurrentMonthAvailable, activeDays) { var _a, _b, _c, _d, _e; return (_e = (_d = (_c = (_b = (_a = checkMinMax(day, minDate, maxDate)) !== null && _a !== void 0 ? _a : checkCurrentMonth(day, month, onlyCurrentMonthAvailable)) !== null && _b !== void 0 ? _b : checkUnavailableDays(day, unavailableDays)) !== null && _c !== void 0 ? _c : checkActiveDay(day, value)) !== null && _d !== void 0 ? _d : checkActiveDays(day, activeDays)) !== null && _e !== void 0 ? _e : checkAvailableDays(day, showCurrentDate); };
var useCalendarDates = function (calendarDatesParams) { return React.useMemo(function () {
    var _a;
    var month = calendarDatesParams.month, value = calendarDatesParams.value, unavailableDays = calendarDatesParams.unavailableDays, minDate = calendarDatesParams.minDate, maxDate = calendarDatesParams.maxDate, showCurrentDate = calendarDatesParams.showCurrentDate, onlyCurrentMonthAvailable = calendarDatesParams.onlyCurrentMonthAvailable, activeDays = calendarDatesParams.activeDays, _b = calendarDatesParams.locale, locale = _b === void 0 ? constants.LOCALE_OPTIONS.EN_US : _b;
    var firstDay = utils.startOfWeek(index.startOfMonth(month.toDate()), { locale: utils.getDateFnsLocale(locale) });
    var lastDay = index.endOfWeek(index.endOfMonth(month.toDate()), { locale: utils.getDateFnsLocale(locale) });
    var days = [];
    var day = moment(firstDay).clone();
    while (day.isSameOrBefore(lastDay)) {
        days.push({
            date: day.date(),
            month: day.month(),
            year: day.year(),
            status: getDayStatus(day.clone(), month.clone(), (_a = value === null || value === void 0 ? void 0 : value.clone()) !== null && _a !== void 0 ? _a : null, unavailableDays, minDate, maxDate, showCurrentDate, onlyCurrentMonthAvailable, activeDays),
        });
        day.add(1, 'day');
    }
    return days;
}, [calendarDatesParams]); };
var useMonthLabel = function (monthMoment, locale) { return monthMoment.toDate().toLocaleDateString(locale, { month: 'long' }); };
var useDateClickHandler = function (handleChange) { return React.useCallback(function (_index, data) {
    var newValue = moment().startOf('day');
    newValue.year(data.year);
    newValue.month(data.month);
    newValue.date(data.date);
    handleChange(newValue);
}, [handleChange]); };

var Calendar = function (_a) {
    var value = _a.value, handleChange = _a.onChange, unavailableDays = _a.unavailableDays, minDate = _a.minDate, maxDate = _a.maxDate, className = _a.className, dataCy = _a.dataCy, dataTestId = _a.dataTestId, onNextMonthClick = _a.onNextMonthClick, onPreviousMonthClick = _a.onPreviousMonthClick, _b = _a.size, size = _b === void 0 ? 'lg' : _b, showCurrentDate = _a.showCurrentDate, alwaysHideOnButtonClick = _a.alwaysHideOnButtonClick, variant = _a.variant, onlyCurrentMonthAvailable = _a.onlyCurrentMonthAvailable, locale = _a.locale, buttons = _a.buttons, isFlexStyle = _a.isFlexStyle, toggle = _a.toggle, activeDays = _a.activeDays, message = _a.message;
    var _c = useMonthState(value, onNextMonthClick, onPreviousMonthClick), month = _c.month, previousMonth = _c.previousMonth, nextMonth = _c.nextMonth;
    var calendarDatesParams = {
        locale: locale, month: month, value: value, unavailableDays: unavailableDays, minDate: minDate, maxDate: maxDate, showCurrentDate: showCurrentDate, onlyCurrentMonthAvailable: onlyCurrentMonthAvailable, activeDays: activeDays,
    };
    var calendarViewData = useCalendarDates(calendarDatesParams);
    var handleDateClick = useDateClickHandler(handleChange);
    var monthLabel = useMonthLabel(month, locale);
    return (React__default.createElement(calendarView.CalendarView, { className: className, title: monthLabel + " " + month.year(), data: calendarViewData, onDateClick: handleDateClick, showLeftArrow: !minDate || month.isAfter(minDate, 'month'), showRightArrow: !maxDate || month.isBefore(maxDate, 'month'), onLeftArrowClick: previousMonth, onRightArrowClick: nextMonth, locale: locale, dataCy: dataCy, dataTestId: dataTestId, size: size, variant: variant, buttons: buttons, isFlexStyle: isFlexStyle, toggle: toggle, alwaysHideOnButtonClick: alwaysHideOnButtonClick, message: message }));
};

exports.Calendar = Calendar;
exports.useCalendarDates = useCalendarDates;
exports.useMonthState = useMonthState;
